<div class="container">
  <div class="offset-sm-1 col-sm-10 col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal pb-4 questxt">{{question}}</h1>
    <!-- <div class="col-sm-6 col-md-6 col-xl-4 m-auto text-left">
    <div class="custom-control custom-checkbox chkbox mb-2">
      <input type="checkbox" class="custom-control-input mgntp10" id="Gas" value="Gas" name="Gas" [(ngModel)]="hgType.gas"
        (click)="getType($event)" />
      <label class="custom-control-label font20" for="Gas">Gas</label>
    </div>
    <div class="custom-control custom-checkbox chkbox mb-2">
      <input type="checkbox" class="custom-control-input mgntp10" id="Electricity" value="Electricity" [(ngModel)]="hgType.electricity"
        name="Electricity" (click)="getType($event)" />
      <label class="custom-control-label font20" for="Electricity">Electricity</label>
    </div>
  </div> -->
    <div class="col-sm-12">
      <div class="d-flex  m-auto col-sm-6 col-md-6 col-xl-8">
        <div class="col-6 q-cards">
          <label class="card card-list w-100 pt-2 text-center d-inline-block pull-right" for="Gas">
            <img src="{{gas_src}}" height="100px">
            <div></div>
            <label for="Gas">Gas</label>
            <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
              <input type="checkbox" class="custom-control-input mgntp10" id="Gas" value="Gas" name="Gas" [(ngModel)]="hgType.gas"
                (click)="getType($event)" />
              <label class="custom-control-label" for="Gas"></label>
            </div>
          </label>
        </div>
        <div class="col-6 q-cards">
          <label class="card card-list w-100 pt-2 text-center d-inline-block pull-left" for="Electricity">
            <img src="{{elec_src}}" height="100px">
            <div></div>
            <label for="Electricity">Electricity</label>
            <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
              <input type="checkbox" class="custom-control-input mgntp10" id="Electricity" value="Electricity"
                [(ngModel)]="hgType.electricity" name="Electricity" (click)="getType($event)" />
              <label class="custom-control-label" for="Electricity"></label>
            </div>
          </label>
        </div>
      </div>
    </div>
    <p class="m-0 mt-4 text-muted tapmsg">{{questionObj && questionObj.chkboxtype}}</p>
    <button  *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'sectbtn': isChecked}"[disabled]="isDisable" (click)="next();">Next</button>
    <div>
      <div class="mt-5">
        <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
          <img src="assets/images/flash.png" class="mb-1" />
          <p class="text-center tiphead">FUN FACT</p>
          <p class="text-center tipmes">{{questionObj && questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">FUN FACT<br>
          <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj && questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box" >
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <div class="row col-sm-12 m-auto">
    <div class="d-flex mt-2">
      <div class="col-6 pl-0 box-shadow-none">
        <label class="card card-list text-center d-inline-block" for="Gas" style="width:100%; height: 180px;">
          <img src="{{gas_src}}" width="60%">
          <label for="Gas" class="col-12">Gas</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
            <input type="checkbox" class="custom-control-input mgntp10" id="Gas_mob" value="Gas" name="Gas" [(ngModel)]="hgType.gas"
              (click)="getType($event)" />
            <label class="custom-control-label" for="Gas"></label>
          </div>
        </label>
      </div>
      <div class="col-6 pr-0 box-shadow-none">
        <label class="card card-list text-center d-inline-block" for="Electricity" style="width:100%; height: 180px;">
          <img src="{{elec_src}}" width="60%">
          <label for="Electricity" class="col-12">Electricity</label>
          <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
            <input type="checkbox" class="custom-control-input mgntp10" id="Electricity_mob" value="Electricity"
              [(ngModel)]="hgType.electricity" name="Electricity" (click)="getType($event)" />
            <label class="custom-control-label" for="Electricity"></label>
          </div>
        </label>
      </div>
    </div>
    <!-- <p class="m-auto text-muted tapmsg">{{questionObj && questionObj.chkboxtype}}</p> -->
    <div style="width:97% !important; text-align: right;">
      <div *ngIf="user_bot" class="ash_box text-right mt-3 mb-3" >
        <h1 class="ansMob text-right">{{type}}</h1>
      </div>
    </div>
    <div *ngIf="showTip">
      <div>
        <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
          <img src="assets/images/flash.png" class="mb-1" style="margin-left:48%" />
          <p class="text-center tiphead">FUN FACT</p>
          <p class="text-center tipmes">{{questionObj && questionObj.tip}}</p>
          <!-- <p class="text-center font-weight-bold">FUN FACT<br>
            <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
    <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-2 col-2 px-0 my-auto">
        <div class="arrow_box">
         <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
        </div>
    </div>
  </div> -->
</div>
<!-- <div class="btm-process webview">
  <div class="text-center" *ngIf="!messagetype">
    <span><img src="assets/images/active15.png"></span>
    <h4 class="clr333 processtxt">15% Completed</h4>
  </div>
  <div class="text-center" *ngIf="messagetype">
    <span><img src="assets/images/active11.png"></span>
    <h5 class="clr333 processtxt">55% Completed</h5>
  </div>
</div> -->